import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import Footer from "../../components/dashboard/footer";
import axios from "axios";
let { lambda, appname } = window.app;
const SubscriptionPlan = () => {
    const { userData } = useContext(contentContext);
    const [image, setImg] = useState('');
    const [subscriptionsData, setSubscriptionsData] = useState([]);
    const navigate = useNavigate();
    // const handleBack = () => {
    //     navigate('/')
    // }
    let id = localStorage.getItem("clientid");
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
    useEffect(() => {
        getClientData()

    }, []);
    useEffect(() => {
        const handlePopState = () => {
            // console.log("Browser back button clicked");
            // You can do custom navigation here
            // Example: navigate("/somewhere");
            navigate("/signin", { state: { flag: true } });
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
    const getClientData = (e) => {
        // GetTimeActivity()   
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/clientInfo?appname=' + appname + "&clientid=" + id
        })
            .then(function (response) {
                //  // console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result?.length > 0) {
                    setSubscriptionsData(response?.data?.result?.[0]);
                }
            });
    }
    // console.log("subcrip[tionDattatatattta", subscriptionsData)
    const submitClick = (e, price) => {
        localStorage.setItem("backto", "/signin")
        if (
            !subscriptionsData ||                          // null or undefined
            (Array.isArray(subscriptionsData) && subscriptionsData.length === 0) || // empty array
            subscriptionsData.subscriptionPrice === 0 ||
            subscriptionsData.subscriptionPrice === "0"
        ) {
            // Basic (free) plan: skip the payment flow entirely and go straight to
            // Stripe bank account setup - it's required before they can add a store.
            navigate("/connectbankaccount", { state: { nextRoute: "/addstore", mandatory: true } });
        } else {
            navigate("/payment", { state: subscriptionsData });
        }


        // navigate('/payment?price=' + price)
    }
    
    // Helper function to format the plan type text
    const getPlanTypeText = () => {
        if (!subscriptionsData?.plantype) return '';
        const planType = subscriptionsData.plantype.toLowerCase();
        if (planType === 'monthly') {
            return 'to be charged Monthly';
        } else if (planType === 'yearly') {
            return 'to be charged Annually';
        }
        return '';
    }
    
    console.log("subscriptionsData", subscriptionsData)
    return (
        <>

            <div className="signin-wrapper get_started" id="signin-wrapper">
                <div className="card">
                    <div className="card-body">
                        <div className="get_started_block">
                            <div className="left">
                                <div className="welcome_block">
                                    <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/First-time-graphic.svg" id="signin-graphic-img" />
                                    <div className="Welcome">
                                        <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/logo-dark.png" className="logo" id="signin-logo" />
                                        <h5>Welcome {subscriptionsData?.businessname},</h5>
                                        <p className="excited">We're excited to have you on board! You can effortlessly manage spots and gain insight through crowd analytics, ensuring increased efficiency for your business and a seamless experience for your visitors!</p>
                                        {/* <p className="need_assistance">Need assistance? Our team is here to help! <br /><span>Email us at @support@myspotsaver.com</span></p> */}
                                        <p className="need_assistance">
                                            Need assistance? Our team is here to help! <br />
                                            <span>
                                                Email us at <a href="mailto:support@myspotsaver.com">support@myspotsaver.com</a>
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div className="subscription-txt">
                                    <p className="plan-txt">
                                        Your subscription Plan is <span className="Rate-Txt">{subscriptionsData?.subscription} {subscriptionsData?.subscriptionPrice ? "$" + subscriptionsData?.subscriptionPrice : 0}</span>
                                        {subscriptionsData?.plantype && (
                                            <span className="plan-type-txt"> {getPlanTypeText()}</span>
                                        )}
                                    </p>
                                    {subscriptionsData?.subscriptionPayment ? (
                                        <p className="Payment-Status">
                                            {subscriptionsData?.subscriptionPayment}
                                            <span className="material-symbols-outlined">error</span>
                                        </p>
                                    ) : null}

                                    <button className="fill-btn save_continue" onClick={e => submitClick(e, subscriptionsData?.subscriptionPrice)}>GET STARTED</button>
                                </div>

                            </div>
                            <div className="right">
                                <div className="right-wrapper">
                                    <h3 className="semi-heading">Get Started</h3>
                                    <p className="excited">Manage your location in 5 simple and easy steps.</p>

                                    <div className="navigation-section">
                                        {/* First because it genuinely is first: GET STARTED goes
                                            straight to /connectbankaccount on both the free path
                                            (submitClick) and the paid one (PaymentPage). Naming it
                                            here is what keeps Stripe from arriving unannounced.
                                            No CDN icon exists for this one, hence the icon font. */}
                                        <div className="navigation-item">
                                            <div className="navigation-icon">
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{ fontSize: "26px", color: "#5D1CD8" }}
                                                    aria-hidden="true"
                                                >
                                                    account_balance
                                                </span>
                                            </div>
                                            {/* .navigation-text is a flex ROW in spot-admin.css, so the
                                                sub-line has to be stacked explicitly - it would
                                                otherwise sit beside the title, not under it. */}
                                            <div className="navigation-text" style={{ flexDirection: "column" }}>
                                                <p className="txt">Connect Your Bank Account</p>
                                                <p className="txt" style={{ fontSize: "12.5px", fontWeight: 400, color: "#6E7191", marginTop: "2px" }}>
                                                    Stripe handles this - and it's required before you can charge for a plan.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/create-store.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Create Locations</p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/set-store-preference.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Set Location Preferences</p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/manage-hours.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Manage Hours</p>
                                            </div>
                                        </div>

                                        <div className="navigation-item mt-4">
                                            <div className="navigation-icon">
                                                <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/final-launch.svg" alt="create-store" />
                                            </div>
                                            <div className="navigation-text">
                                                <p className="txt">Launch</p>
                                            </div>
                                        </div>


                                    </div>

                                    <p className="plan-txt">Let's create a smoother booking experience together!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

        </>
    );
};

export default SubscriptionPlan;